// CoPilot screen awareness (CP-7, Specs/CoPilot — Claude Code + LangGraph — PRD). Kyle (Oct 27):
// a key feature that never really worked — the panel only ever saw the breadcrumb's names, no ids.
// Now: what's open (kind + id + title) comes from the page's address, which already carries the ids,
// and the title from the breadcrumb (the chips). The CoPilot reads the real content by id itself.
// Removing a chip (its breadcrumb label) keeps that item from being sent.

export interface ScreenItem { kind: string; id: string; title: string }
type Crumb = { label?: unknown };

const labels = (crumbs: Crumb[]) => (Array.isArray(crumbs) ? crumbs : []).map((c) => String((c && c.label) || "")).filter(Boolean);

export const screenFor = (pathname: string, search: string, crumbs: Crumb[]): ScreenItem[] => {
  const parts = pathname.split("/").filter(Boolean);
  const q = new URLSearchParams(search);
  const names = labels(crumbs);
  // the breadcrumb ends with the open item's name; the one before is its parent's
  const last = names[names.length - 1] || "";
  const parent = names[names.length - 2] || "";
  const has = (n: number) => names.length >= n;
  const item = (kind: string, id: string | null, title: string): ScreenItem[] => (id ? [{ kind, id, title }] : []);

  const [app, a, b, c] = parts;
  if (app === "funnels" && a && b) return has(3) ? [...item("page", b, last), ...item("campaign", a, parent)] : [];
  if (app === "funnels" && a) return has(2) ? item("campaign", a, last) : [];
  if (app === "sites" && a && b === "html" && c) return has(3) ? [...item("html page", c, last), ...item("site", a, parent)] : [];
  if (app === "sites" && a && b) return has(3) ? [...item("page", b, last), ...item("site", a, parent)] : [];
  if (app === "sites" && a) return has(2) ? item("site", a, last) : [];
  if (app === "crm" && a === "contacts" && b) return has(3) ? item("contact", b, last) : [];
  if (app === "reviews" && a) return has(2) ? item("review room", a, last) : [];
  if (app === "agents") {
    if (a === "digest") return item("meeting", q.get("id"), last);
    if (a === "transcript-view") return item("document", q.get("id"), last);
    if (a === "reviews") return item("review", q.get("open"), last);
    if (a === "campaigns") return item("agents campaign", q.get("campaign"), last);
  }
  return [];
};

export const screenFrom = (crumbs: Crumb[]): ScreenItem[] =>
  typeof window === "undefined" ? [] : screenFor(window.location.pathname, window.location.search, crumbs);
